import TYPES from './_types';

export default {
  [TYPES.UPDATE_CITY](state, data) {
    state.selectedCity = data;
  },
  [TYPES.UPDATE_POSITION_STATUS](state, data) {
    state.positionStaus = data;
  },
  [TYPES.UPDATE_LOCALADDRESS](state, data) {
    state.localAddress = data;
  },
  [TYPES.UPDATE_CURRENT](state, data) {
    state.current = data;
  },
  [TYPES.UPDATE_ADDRESS_INFO](state, data) {
    const {
      province,
      city,
      district,
      nearBy,
      current
    } = data;
    state.province = province;
    state.city = city;
    state.selectedCity = city;
    state.cityName = city;
    state.district = district;
    state.nearBy = nearBy;
    state.localAddress = nearBy[0];
    state.current = current;
  }
};



// WEBPACK FOOTER //
// ./src/stores/location/_mutations.js